<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};

</script>

<style lang="scss">
$primary: #4dbd74 !default;

/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
// @import "assets/scss/style";

// css added from here
@import "assets/css/sb-admin-2.min.css";
@import "assets/vendor/fontawesome-free/css/all.min.css";

body {
  font-family: Meiryo, Hiragino Kaku Gothic Pro, sans-serif;
  color: black;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: black !important;
}

.formTextSize {
  color: #4360b7;

  font-size: 13px;
}

.formTextSizeBlack {
  font-size: 13px;
}

.formTextSize14 {
  font-size: 16px;
}
.customButton {
  margin: 5px;
}
.customAddButtonStyle {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
}
.customTextRight {
  text-align: right;
}
.toast-icon {
  top: 11px !important;
}

#ctable thead th {
  text-align: center !important;
}
@media (max-width:1000px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media (max-width: 1000px) {
  .table {
    width: 1076px;
  }
}

@media (min-width: 768px) {
  .d-md-inline {
    display: block !important;
  }
}
@media (max-width: 600px) {
 
  .search-text-box{
    width: 100% !important;
    margin: 0px 0px 36px !important;
  }
}

// @media (max-width: 414px) {
//   .sidebar {
//     width: 0;
//     overflow: hidden !important;
//   }
//   .sidebar.toggled {
//     width: 7.5rem !important;
//   }
// }

.toast-success {
  background-color: #51a351 !important;
}
.toast-error {
  background-color: #bd362f !important;
}
.wrapText {
  text-overflow: ellipsis;
  overflow: hidden;
}
.custom-header{
  margin-top: 14px;
}
.mandotry-color{
  color:red;
}
.custom-pagination-font{
  font-size:12px;
}
em{
  font-size:14px;
}

</style>
